import { markerSchema } from '@/models/markerSchema';
import { markerIdsSetSelector } from '@/redux/markers/markers.selectors';
import { updateMarkerInMarkersData } from '@/redux/markers/markers.slice';
import { store } from '@/redux/store';
import type { Marker } from 'minerva-plugin-api';

export const updateSingleMarker = (marker: Marker): Marker => {
  const { dispatch, getState } = store;
  markerSchema.parse(marker);

  if (!markerIdsSetSelector(getState()).has(marker.id)) {
    throw new Error(`Marker with id "${marker.id}" is not shown. Use addSingleMarker to add it.`);
  }

  dispatch(updateMarkerInMarkersData(marker));

  return marker;
};
